package com.milta.feature.auth.data.remote.dto

import kotlinx.serialization.Serializable

@Serializable
data class UpdatePendingPhoneRequest(
    val provider: String,
    val idToken: String,
    val phoneNumber: String,
)
